import React, { ReactNode } from 'react';

import { FormCheck as BsFormCheck } from 'react-bootstrap';

export type FormCheckPropsT = {
  id: string;
  label: React.ReactNode;
  type: 'checkbox' | 'radio';
  checked?: boolean;
  className?: string;
  defaultChecked?: boolean;
  disabled?: boolean;
  errorMessage?: ReactNode;
  groupError?: boolean;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  value?: string | number;
};

export const FormCheck: React.FC<FormCheckPropsT> = ({
  errorMessage,
  groupError,
  ...props
}) => {
  return (
    <BsFormCheck
      {...props}
      feedback={groupError ? undefined : errorMessage}
      feedbackType="invalid"
      isInvalid={!!errorMessage}
    />
  );
};
